<span *ngIf="recordCount < 1 ? displayWhenZero : true">{{ recordCount }}&nbsp;{{ recordCount === 1 ? singularLabel : multipleLabel }}</span>
